import AppErrorPage from './AppErrorPage'
import { ErrorBoundary } from 'react-error-boundary'
import posthog from 'posthog-js'

export default function ReactErrorBoundary(props) {
	return (
		<ErrorBoundary
			FallbackComponent={AppErrorPage}
			onError={(error, errorInfo) => {
				// log the error
				console.log('Error caught!')
				console.error(error)
				console.error(errorInfo)

				// errors caught here never reach PostHog's exception autocapture, so report them explicitly.
				// Only apps that initialise PostHog (app_frontend) have it loaded.
				if (posthog.__loaded) {
					posthog.captureException(error, {
						componentStack: errorInfo?.componentStack,
						handled_by: 'ReactErrorBoundary',
					})
				}
			}}
		>
			{props.children}
		</ErrorBoundary>
	)
}
